<template>
  <div>
    <p>Montant {{ isRecurringDonation ? "de chaque versement" : "" }}:</p>
    <v-item-group :value="selectedAmount" class="mb-5" active-class="primary--text accent-2" @change="selectSuggestion($event)">
      <div class="d-flex flex-wrap">
        <DonationSuggestion
          v-for="suggestion in suggestions"
          :key="suggestion.id"
          class="mr-5 mb-2"
          :suggestion="suggestion"
          :is-recurring-donation="isRecurringDonation"
        />
        <DonationSuggestion :suggestion="otherSuggestion" :is-other-amount="true" />
      </div>
    </v-item-group>
    <v-alert v-if="!!selectedSuggestion && selectedSuggestion.fullDescription" text color="primary">
      {{ selectedSuggestion.fullDescription }}
    </v-alert>
    <v-text-field
      v-if="selectedSuggestion && !selectedSuggestion.amount"
      label="Autre montant"
      type="number"
      :value="amount"
      min="0"
      :prefix="currency.unit"
      :outlined="isOutlined"
      :dense="isDense"
      style="max-width: 150px"
      @blur="setCustomAmount($event)"
    />
  </div>
</template>

<script>
import DonationSuggestion from "@/components/DonationSuggestion"
import { EventBus } from "@/main.js"
import { mapGetters } from "vuex"

export default {
  components: {
    DonationSuggestion
  },
  props: {
    isRecurringDonation: {
      type: Boolean,
      default: false
    },
    suggestions: {
      type: Array,
      default: () => []
    },
    selectedAmount: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      selectedSuggestion: undefined,
      amount: 0
    }
  },
  computed: {
    ...mapGetters(["formParams", "currency", "t", "isOutlined", "isDense"]),
    otherSuggestion() {
      return {
        amount: undefined,
        description: this.t("AUTRE_MONTANT")
      }
    }
  },
  mounted() {
    this.selectSuggestion(this.suggestions[0])
  },
  methods: {
    selectSuggestion(newValue) {
      this.selectedSuggestion = newValue
      if (newValue && newValue.amount !== undefined) {
        this.amount = newValue.amount
      } else {
        this.amount = 0
      }
      EventBus.$emit("select-amount", this.amount || 0)
    },
    setCustomAmount(event) {
      if (event.target) {
        this.amount = Number(event.target.value)
        EventBus.$emit("select-amount", this.amount || 0)
      }
    }
  }
}
</script>

<style scoped>
</style>